import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ae0e6558"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = { class: "no-flex" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "API:", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Client time:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "OBID:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "WS:", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "UI version: ", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Mode:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "DH:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "DH Progress:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Public internet:", -1))
const _hoisted_13 = { key: 0 }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Admin", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "RC version:", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Unsynced:", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Internal IP:", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonBase = _resolveComponent("ButtonBase")!

  return (_openBlock(), _createElementBlock("div", {
    class: "status-panel",
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("h5", null, [
      _createTextVNode(_toDisplayString(_ctx.userStore.user.address.company) + " ", 1),
      _createElementVNode("span", null, "#" + _toDisplayString(_ctx.userStore.user.id), 1)
    ]),
    _hoisted_1,
    _createElementVNode("p", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("span", null, _toDisplayString(_ctx.api), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_5,
      _createElementVNode("span", null, _toDisplayString(_ctx.time), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_6,
      _createElementVNode("span", null, _toDisplayString(_ctx.obId), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_7,
      _createElementVNode("span", null, _toDisplayString(_ctx.websocketStatus) + " / " + _toDisplayString(_ctx.websocketSubscription), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_8,
      _createElementVNode("span", null, _toDisplayString(_ctx.uiVersion), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_9,
      _createElementVNode("span", null, _toDisplayString(_ctx.mode), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_10,
      _createElementVNode("span", null, _toDisplayString(_ctx.dataHydrationStatus), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_11,
      _createElementVNode("span", null, _toDisplayString(_ctx.dataHydrationProgress), 1)
    ]),
    _createElementVNode("p", null, [
      _hoisted_12,
      _createElementVNode("span", null, _toDisplayString(_ctx.internetStatus), 1)
    ]),
    (_ctx.userStore.user.is_admin)
      ? (_openBlock(), _createElementBlock("p", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("span", null, _toDisplayString(_ctx.userStore.user.is_admin), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.RiceCooker.isPresent())
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_15,
          _createElementVNode("p", null, [
            _hoisted_16,
            _createElementVNode("span", null, _toDisplayString(_ctx.riceCookerVersion), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_17,
            _createElementVNode("span", null, _toDisplayString(_ctx.unsyncedOfflineOrders), 1)
          ]),
          _createElementVNode("p", null, [
            _hoisted_18,
            _createElementVNode("span", null, _toDisplayString(_ctx.internalIp), 1)
          ]),
          _hoisted_19,
          _createVNode(_component_ButtonBase, {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goToDebug())),
            class: "m-0",
            style: {"width":"100%"},
            variant: "outlined",
            icon: "eye-glasses"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Debug")
            ]),
            _: 1
          }),
          _createVNode(_component_ButtonBase, {
            class: "m-0 mt-2",
            style: {"width":"100%"},
            variant: "outlined",
            onClick: _ctx.toggleOnlineOffline
          }, {
            default: _withCtx(() => [
              _createTextVNode("Toggle online/offline")
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_ButtonBase, {
            class: "m-0 mt-2",
            style: {"width":"100%"},
            variant: "outlined",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updatesStore().doUpdateChecks())),
            loading: _ctx.updatesStore().doingUpdateChecks
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Force update check ")
            ]),
            _: 1
          }, 8, ["loading"])
        ], 64))
      : _createCommentVNode("", true),
    _createVNode(_component_ButtonBase, {
      "v-if": Boolean(Number(_ctx.useSettingsStore().settings.masterslave)),
      class: _normalizeClass({
                'm-0': true,
                'mt-2': _ctx.RiceCooker.isPresent(),
            }),
      loading: _ctx.useUserStore().togglingMasterSlave,
      style: {"width":"100%"},
      variant: "outlined",
      onClick: _ctx.toggleMasterSlave
    }, {
      default: _withCtx(() => [
        _createTextVNode("Toggle master/slave")
      ]),
      _: 1
    }, 8, ["v-if", "class", "loading", "onClick"]),
    (_ctx.dataHydration.isActive())
      ? (_openBlock(), _createBlock(_component_ButtonBase, {
          key: 2,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.dataHydration.hydrateAll(false, true))),
          variant: "outlined",
          style: {"width":"100%"},
          class: "mt-2",
          loading: _ctx.isHydrating
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Toggle DataHydration ")
          ]),
          _: 1
        }, 8, ["loading"]))
      : _createCommentVNode("", true),
    (_ctx.hasVoip)
      ? (_openBlock(), _createBlock(_component_ButtonBase, {
          key: 3,
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.subscribeToCallerIdEvents(true))),
          variant: "outlined",
          style: {"width":"100%"},
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Subscribe to CallerID (Status: " + _toDisplayString(_ctx.callerIdActive ? "Connected" : "Disconnected") + ") ", 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.showImpersonationButton)
      ? (_openBlock(), _createBlock(_component_ButtonBase, {
          key: 4,
          onClick: _ctx.adminImpersonation,
          variant: "outlined",
          style: {"width":"100%"},
          class: "mt-2"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Toggle admin (" + _toDisplayString(_ctx.translate(_ctx.userStore.user.is_admin ? "active" : "inactive")) + ") ", 1)
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true)
  ]))
}